import classNames from "classnames";
import * as React from "react";
import { koPeopleTemplatesResx } from "../../resxDist/koPeopleTemplatesResx";
import * as virtListStyles from "./VirtList.less";

type Props = {
    text?: string;
    className?: string;
    width?: number;
};

export const NoItemsMessage = (props: Props) => {
    const { text, className, width } = props;
    const style = { cursor: "default", width };

    return (
        <div className={classNames(virtListStyles.row, className)} style={style}>
            <span className={virtListStyles.label}>{text || koPeopleTemplatesResx.nomatch_text}</span>
        </div>
    );
};
